export default "__VITE_ASSET__Do9XNLv6__"